export const link = "https://apv.sumadepobangunan.com/";
export const linkWeb = "https://admin.sumadepobangunan.com/";

// export const link = "http://localhost:5000/";
// export const linkWeb = "http://localhost:3000/";